import "./Sidepanel.css";
import "./circle.css";

function Sidepanel(props) {
  const autoScrollToCategory = (className) => {
    const element = document.getElementsByClassName(`${className}`);
    const elementExist = element && element.length > 0;
    if (!elementExist) {
      return;
    }

    clearTimeout(scrollToCategory);
    var scrollToCategory = setTimeout(function () {
      element[0].scrollIntoView({ behavior: "smooth" });
      clearTimeout(scrollToCategory);
    }, 100); // 100 milliseconds delay
  };

  return (
    <div className="sidepanel-container">
      <div className="sidepanel-header">
        <span>CTA Eligibility Wizard</span>
      </div>

      <div className="sidepanel-container-li company-overview-li">
        <div className="circle">
          {props.IsCompanyOverviewCompleted && (
            <span className="tick-icon">&#10004;</span>
          )}
        </div>
        <div
          className="sidepanel-li-label"
          onClick={() => autoScrollToCategory("company-overview")}
        >
          <span>Company Overview</span>
        </div>
      </div>

      <div className="sidepanel-vertical-line"></div>

      <div className="sidepanel-container-li filing-excemption-li">
        <div className="circle">
          {props.IsFilingCompleted && (
            <span className="tick-icon">&#10004;</span>
          )}
        </div>
        <div
          className="sidepanel-li-label"
          onClick={() => autoScrollToCategory("filing-exemptions")}
        >
          <span>Filing Exemptions</span>
        </div>
      </div>

      <div className="sidepanel-vertical-line"></div>

      <div className="sidepanel-container-li results-li">
        <div className="circle">
          {props.IsResultCompleted && (
            <span className="tick-icon">&#10004;</span>
          )}
        </div>
        <div
          className="sidepanel-li-label"
          onClick={() => autoScrollToCategory("result")}
        >
          <span>Results</span>
        </div>
      </div>

      <div className="need-help-container">
        <a
          target="_blank"
          href="https://www.rasi.com/corporate-transparency/ctacomply.asp"
        >
          <span className="need-help">Learn More</span>
        </a>
      </div>
    </div>
  );
}

export default Sidepanel;
